import React from 'react';
import { clsx } from 'clsx';
import Image from '@/src/shared/components/Image';
import styles from './JoinOverRow.module.scss';

type Props = {
  logos: Array<{
    title: string;
    icon: string;
    width?: number;
    height?: number;
  }>;
  className?: string;
  classes?: {
    logoContainer?: string;
  };
};

export default function BrokerageLogoGroup({
  logos,
  classes,
  className,
}: Props) {
  return (
    <div className={clsx(styles.logoGroupContainer, className)}>
      {logos.map(({ title, icon, width, height }) => {
        const isSizeDefined = width != null && height != null;
        return (
          <div
            key={`realtor-logo-${title}`}
            className={clsx(
              styles.realtorLogoContainer,
              { [styles.withSize]: isSizeDefined },
              classes?.logoContainer
            )}
          >
            <Image
              src={icon}
              alt={title}
              width={width}
              height={height}
              fill={!isSizeDefined}
              quality={100}
            />
          </div>
        );
      })}
    </div>
  );
}
